'use strict';

var passwordHelper = {
    requirements: {
        minLength: { pattern: /^.{12,}$/, selector: 'li[data-requirement="minLength"]' },
        uppercase: { pattern: /[A-Z]/, selector: 'li[data-requirement="uppercase"]' },
        lowercase: { pattern: /[a-z]/, selector: 'li[data-requirement="lowercase"]' },
        number: { pattern: /[0-9]/, selector: 'li[data-requirement="number"]' },
        special: { pattern: /[!@#$%^&*]/, selector: 'li[data-requirement="special"]' }
    },

    init: function(passwordInput, options) {
        options = options || {};
        var $input = $(passwordInput);
        if (!$input.length) return;

        var $helpText = options.helpTextSelector 
            ? $(options.helpTextSelector) 
            : $input.closest('.form-group').find('.password-requirement-help-text');
        if (!$helpText.length) return;

        var self = this;
        $input.on('input', function() { self.updateRequirements($input, $helpText); });
        self.updateRequirements($input, $helpText);
    },

    updateRequirements: function($input, $helpText) {
        var password = $input.val();
        var self = this;

        Object.keys(this.requirements).forEach(function(key) {
            var requirement = self.requirements[key];
            var $item = $helpText.find(requirement.selector);
            if (!$item.length) return;

            var isMet = requirement.pattern.test(password);

            if (isMet) {
                $item.addClass('completed');
                if (!$item.find('.requirement-icon').length) {
                    $item.prepend('<span class="requirement-icon">✓</span>');
                }
            } else {
                $item.removeClass('completed');
                $item.find('.requirement-icon').remove();
            }
        });
    },

    initializeAll: function() {
        var self = this;
        $('input[type="password"]').each(function() {
            var $helpText = $(this).closest('.form-group').find('.password-requirement-help-text');
            if ($helpText.length) {
                self.init(this);
            }
        });
    }
};

module.exports = function() { passwordHelper.initializeAll(); };
